module.exports = __webpack_public_path__ + "img/curved-down-arrow.a9547bec.svg";